import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { FOTO_FLAT, ORIGINAL, SOCIAL_MEDIA } from '../../../utils/variables';

import environment from '../../../environment';
import GenerateZipMutation from '../../../mutations/GenerateZipMutation';
import RestartProductionMutation from '../../../mutations/RestartProductionMutation';
import AccountDownloadTileButton from './AccountDownloadTileButton';

import CircularProgress from '@material-ui/core/CircularProgress';

const AccountDownloadTileZipDownload = ({
  icon,
  textInSpan,
  restartState,
  eventSgId,
  type,
  values,
  isFaceSearchEvent,
  notActive,
}) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [isRestartRequestPending, setIsRestartRequestPending] = useState(false);
  const [isRestartRequestSent, setIsRestartRequestSent] = useState(false);
  const hasOptions = type === 'all_photos' || (type === FOTO_FLAT && values?.length > 1);
  const initialValuesForAvailableZips = values?.map((value) => ({
    id: value,
    url: null,
  }));
  const [downloadableZipsData, setDownloadableZipsData] = useState(
    initialValuesForAvailableZips
  );

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (error) {
      setError(false);
    }
    setOpen(true);
  };

  const download = (url) => {
    window.location.href = url;
  };

  const updateState = (idToUpdate, newUrl) => {
    let stateCopy = [...downloadableZipsData];
    const indexToUpdate = stateCopy.findIndex((item) => item.id === idToUpdate);
    if (indexToUpdate !== -1) {
      stateCopy[indexToUpdate].url = newUrl;
      setDownloadableZipsData(stateCopy);
    }
  };

  const generateZipDownloadLink = (zipName) => {
    setIsPending(true);
    setOpen(false);
    GenerateZipMutation.commit(environment, eventSgId, zipName, (errorMsg, url) => {
      if (!errorMsg) {
        updateState(zipName, url);
        download(url);
      } else {
        setError(true);
      }
      setIsPending(false);
    });
  };

  const handleButtonClicked = (zipName) => {
    const zipData = downloadableZipsData.find((item) => item.id === zipName);
    if (zipData?.url) {
      download(zipData.url);
    } else if (type === 'all_photos' || type === FOTO_FLAT) {
      generateZipDownloadLink(zipName);
    }
  };

  const handleRestartUpload = () => {
    setIsRestartRequestPending(true);
    RestartProductionMutation.commit(environment, eventSgId, (error, status) => {
      if (!error) {
        setIsRestartRequestSent(true);
      } else {
        setError(true);
      }
    });
    setIsRestartRequestPending(false);
  };

  const defineMainAction = () => {
    if (hasOptions) {
      handleOpen();
      return;
    } else {
      handleButtonClicked(downloadableZipsData[0].id);
      return;
    }
  };

  return (
    <AccountDownloadTileButton
      icon={icon}
      textInSpan={textInSpan}
      onClick={() => {
        defineMainAction();
      }}
      hasOpenedOptions={open}
      hasOptions={hasOptions}
      onCloseOptions={handleClose}
      isPending={isPending}
      error={error}
      notActive={notActive}
    >
      {open && (
        <div className="dropdown">
          {type === FOTO_FLAT &&
            hasOptions &&
            values.map((availableFotoFlat) => {
              return (
                <button
                  key={availableFotoFlat}
                  onClick={() => handleButtonClicked(availableFotoFlat)}
                  className="dropdown-item"
                >
                  {isFaceSearchEvent ? (
                    <FormattedMessageWrappedInSpan
                      id="accountEventPage.products.fotoFlatId"
                      defaultMessage="Foto-Flat ID"
                      className="dropdown-label"
                    />
                  ) : (
                    <FormattedMessageWrappedInSpan
                      id="accountEventPage.products.bibNumber"
                      defaultMessage="Bib number"
                      className="dropdown-label"
                    />
                  )}
                  <span>{availableFotoFlat}</span>
                </button>
              );
            })}

          {type === 'all_photos' && (
            <>
              <button
                onClick={() => handleButtonClicked(SOCIAL_MEDIA)}
                className="dropdown-item"
              >
                <FormattedMessageWrappedInSpan
                  id="accountEventPage.dropdown.socialMediaZip"
                  defaultMessage="Social media resolution"
                />
              </button>

              {restartState === 'nothing_to_restart' && (
                <button
                  onClick={() => handleButtonClicked(ORIGINAL)}
                  className="dropdown-item"
                >
                  <FormattedMessageWrappedInSpan
                    id="accountEventPage.dropdown.highResZip"
                    defaultMessage="High resolution"
                  />
                </button>
              )}
              {(restartState === 'processing' || isRestartRequestSent) && (
                <button
                  onClick={handleClose}
                  className="dropdown-item dropdown-note"
                  notActive={true}
                >
                  <FormattedMessageWrappedInSpan
                    id="accountPhotoDownload.default.processingNotation"
                    defaultMessage="Photos in high resolution are coming soon"
                  />
                </button>
              )}
              {restartState === 'can_restart' && !isRestartRequestSent && (
                <button
                  onClick={() => handleRestartUpload()}
                  className="dropdown-item"
                  notActive={isRestartRequestPending}
                >
                  {isRestartRequestPending ? (
                    <CircularProgress size={15} />
                  ) : (
                    <FormattedMessageWrappedInSpan
                      id="accountEventPage.dropdown.highResRestart"
                      defaultMessage="Request high resolution photos"
                    />
                  )}
                </button>
              )}
            </>
          )}
        </div>
      )}
    </AccountDownloadTileButton>
  );
};

AccountDownloadTileZipDownload.propTypes = {
  icon: PropTypes.object,
  textInSpan: PropTypes.object,
  notActive: PropTypes.bool,
  restartState: PropTypes.string,
  eventSgId: PropTypes.number,
  type: PropTypes.string,
  values: PropTypes.array,
  isFaceSearchEvent: PropTypes.bool,
};

export default AccountDownloadTileZipDownload;
